module.exports = __webpack_public_path__ + "img/dkzy1.80960f61.png";